import axios from 'axios'
import { REACT_APP_API } from '../../config'

export async function postRefreshJob(body) {
    try {
        const result = await axios.post(`${REACT_APP_API}/pipelines/execute`,body)
        return result.data
    } catch (error) {
        console.log(`Error postRefreshJob `, error)
        return error;
    }    
}